import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {UserService} from "../../../global/services/user.service";
import {CryptoService} from "../../../global/services/crypto.service";
import {Router} from "@angular/router";
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {DataService} from "../../../global/services/data.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from '../../../interfaces';
import {NgForOf, NgIf} from "@angular/common";
import {RightPipe} from "../../../global/pipes/right.pipe";
import {EventTypePipe} from "../../../global/pipes/event-type.pipe";
import {Subscription} from "rxjs";
import {ActionTypePipe} from "../../../global/pipes/action-type.pipe";

@Component({
    selector: 'app-event-detail',
    imports: [
        FormsModule,
        NgForOf,
        NgIf,
        ReactiveFormsModule,
        RightPipe,
        EventTypePipe,
        ActionTypePipe
    ],
    templateUrl: './event-detail.component.html',
    styleUrl: './event-detail.component.scss'
})
export class EventDetailComponent implements OnInit, OnDestroy {

    userService = inject(UserService);
    private cryptoService = inject(CryptoService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);

    ViewMode = ViewMode;

    form!: UntypedFormGroup;
    EVAID!: string;
    viewMode!: ViewMode;
    event: any;

    fileTypes!: any[];
    attributes!: any[];

    private changesList$: Subscription[] = [];

    ngOnInit(): void {
        const urlData = this.cryptoService.getUrlData(this.router.url);
        this.EVAID = urlData.ID;
        this.viewMode = urlData.viewMode;

        this.form = this.fb.group({
            EVAID: [null],
            type: ['', Validators.required],
            action: ['', Validators.required],
            data: this.fb.group({
                FTID: [''],
                ATTID: [''],
            })

        });

        if (this.EVAID !== '0') {
            this.getEvent();
        }

        this.changesList$.push(this.form.get('action').valueChanges.subscribe(_ => {
            this.form.get('data.FTID')?.setValue('');
            this.form.get('data.ATTID')?.setValue('');

            this.dataService.request('FileType/listAll').subscribe(response => {
                this.fileTypes = response.filetypes;
            });
        }));

        this.changesList$.push(this.form.get('data.FTID')!.valueChanges.subscribe(value => {
            if (value != '') {
                this.dataService.request('FileType/get', {FTID: value}).subscribe(response => {
                    this.attributes = response.attributes.filter(attribute => attribute.required == '1');
                });
            }
        }));
    }

    ngOnDestroy(): void {
        this.changesList$.forEach(element => {
            element.unsubscribe();
        });
    }

    getEvent(): void {
        this.dataService.request('Event/get', {
            EVAID: this.EVAID
        }).subscribe(response => {
            this.event = response.event;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            EVAID: this.event.EVAID,
            type: this.event.type,
            action: this.event.action,
            data: this.event.data
        });
    }

    save(): void {
        this.dataService.request('Event/save', this.form.getRawValue()).subscribe(() => {
            this.toastrService.success('Aktion wurde gespeichert');
            this.router.navigate(['/app/event']);
        });
    }

    update(): void {
        this.dataService.request('Event/update', this.form.getRawValue()).subscribe(() => {
            this.toastrService.success('Aktion wurde aktualisiert');
            this.setMode(ViewMode.VIEW);
            this.getEvent();
        });
    }

    cancel(): void {
        this.router.navigate(['/app/event']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Aktion wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Event/delete', {
                    EVAID: this.EVAID
                }).subscribe(() => {
                    this.toastrService.success('Aktion wurde gelöscht');
                    this.cancel();
                });
            }
        });
    }
}
